import { Routes } from "@/features/router";
import { IdentificationIcon } from "@heroicons/react/20/solid";
import _ from "lodash";
import type React from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { MenuItem } from "./index.react";
import { ChevronLeftIcon } from "@heroicons/react/24/solid";
import { CardTitle, Info } from "@/atoms-react/text/Text.react";
import { useMediaQuery } from "usehooks-ts";
import { useCompanyContext } from "@/features/company/hooks/use-company-context";
import { BuildingLibraryIcon } from "@heroicons/react/24/outline";

type MenuAccountProps = {
  open: boolean;
  onClose: () => void;
} & React.ComponentPropsWithoutRef<"div">;

export const MenuAdminAccount = ({ open, onClose, ...props }: MenuAccountProps) => {
  const { t } = useTranslation(["pass"]);
  const isNotMobile = useMediaQuery("(min-width: 768px)");
  const { leUuid } = useCompanyContext();
  return (
    <div
      className={twMerge(
        "absolute h-full w-64 shrink-0 border-slate-50 border-r bg-white px-4 py-6 lg:relative lg:w-80 lg:px-8 dark:border-slate-900 dark:bg-slate-950",
        "dark: -translate-x-full transition-all lg:translate-x-0",
        "z-50 overflow-auto",
        open ? "translate-x-0" : ""
      )}
      {..._.omit(props, "className")}
    >
      <div
        className={twMerge("mb-4 flex cursor-pointer items-center gap-x-1", isNotMobile && "h-12")}
        data-cy="close-menu-item"
        onClick={onClose}
      >
        <ChevronLeftIcon className="h-5 w-5 text-black dark:text-white" />
        <CardTitle className="block">
          {t("olkypass.mainPage.navigation_menu.link.admin_home")}
        </CardTitle>
      </div>
      {isNotMobile && <Info className="mt-10 block"></Info>}

      <MenuItem to={`${Routes.level}/${leUuid}`} icon={(p) => <IdentificationIcon {...p} />}>
        {t("olkypass.mainPage.navigation_account_menu.link.level")}
      </MenuItem>
      <MenuItem
        icon={(p) => <BuildingLibraryIcon {...p} />}
        to={`${Routes.companies}/${leUuid}/related_person`}
      >
        <div data-cy="navigation-menu-item-company-representative">
          {t("olkypass.mainPage.navigation_menu.link.company_representative")}
        </div>
      </MenuItem>
    </div>
  );
};
